import { render } from "./DRangeSwitcher.vue?vue&type=template&id=56feaf12&scoped=true"
import script from "./DRangeSwitcher.vue?vue&type=script&lang=js"
export * from "./DRangeSwitcher.vue?vue&type=script&lang=js"

import "./DRangeSwitcher.vue?vue&type=style&index=0&id=56feaf12&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56feaf12"]])

export default __exports__